export default __webpack_public_path__ + "static/media/soulbarrier.204709f2.png";